module.exports = __webpack_public_path__ + "quilt3-level6.170e0d93.png";